export enum AGENCY_STATUS {
  APPROVED = 'Approved',
  DENIED = 'Denied',
  CONTRACTING = 'Contracting',
  INACTIVE = 'Inactive',
  INVESTIGATING = 'Investigating',
  NEW_AGENCY = 'New Agency',
}
